import BlobService from '@/services/blob-service';
import vkbeautify from 'vkbeautify';

export default {
	methods: {
		async showTransactionRequest(uri) {
			return await BlobService.getSecureVueTransaction(
				uri,
				'application/xml'
			);
		},
		formatToXML(val) {
			return vkbeautify.xml(val);
		},
		downloadXMLTransaction(fileName, transactionFile) {
			let blob = new Blob([transactionFile], {
				type: 'text/xml'
			});
			if (!blob) {
				let url = URL.createObjectURL(blob);
				let a = document.createElement('a');
				a.href = url;
				a.download = `${fileName}`;
				a.style.display = 'none';
				document.body.appendChild(a);
				a.click();
			}
		}
	}
};
